import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import FieldIconWrapper from 'common/components/form/FieldIconWrapper';

const FieldInput = ({
  autoFocus,
  className = '',
  handleChange = () => {},
  inputSize,
  name = '',
  placeholder,
  type = 'text',
  value = '',
  readOnly,
  disabled,
  maxLength,
  ...passThroughProps
}) => (
  <FieldIconWrapper {...passThroughProps}>
    <input
      className={classnames(
        'form-control',
        {
          [`form-control-${inputSize}`]: !!inputSize,
          'is-invalid': passThroughProps.error && Object.keys(passThroughProps.error).length > 0,
        },
        className
      )}
      name={name}
      placeholder={placeholder}
      type={type}
      value={value}
      onChange={handleChange}
      autoFocus={autoFocus}
      readOnly={readOnly}
      disabled={disabled}
      maxLength={maxLength}
    />
  </FieldIconWrapper>
);

FieldInput.propTypes = {
  type: PropTypes.string,
  value: PropTypes.any,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  autoFocus: PropTypes.bool,
  error: PropTypes.object,
  handleChange: PropTypes.func,
  inputSize: PropTypes.oneOf(['lg', 'sm']),
  iconRight: PropTypes.string,
  iconLeft: PropTypes.string,
  iconRightSize: PropTypes.oneOf(['lg', '2x', '3x', '4x', '5x']),
  iconRightSpin: PropTypes.bool,
  iconLeftSize: PropTypes.oneOf(['lg', '2x', '3x', '4x', '5x']),
  iconLeftSpin: PropTypes.bool,
};

export default FieldInput;



// WEBPACK FOOTER //
// src/modules/common/components/form/FieldInput.js